module.exports = __webpack_public_path__ + "img/aboutwacca@2x.a8ec1243.png";